import React from "react";
import styled from "styled-components";
import Placeholder from '../../../../core-components/Shimmer/ShimmerUI';

const ListingCardLoaderUI = () => {
  return (
    <ListingLoader>
      <ListingLoaderHdr>
        <Placeholder
          ldrWidth="11.8rem"
          ldrHeight="6.7rem"
          margin="0 2.5rem 0 0"
        />
        <div>
          <Placeholder
            display="flex"
            ldrWidth="260px"
            ldrHeight="2rem"
            margin="0 0 0.8rem 0"
          />
          <Placeholder display="flex" ldrWidth="182px" ldrHeight="1.7rem" />
        </div>
      </ListingLoaderHdr>
      <ListingLoaderContent>
        <div className="contentLeft">
          <div className="contentLeft__top">
            <Placeholder display="flex" ldrWidth="260px" ldrHeight="2rem" />
            <Placeholder display="flex" ldrWidth="10.2rem" ldrHeight="2rem" />
          </div>
          <Placeholder
            display="flex"
            ldrWidth="320px"
            ldrHeight="1.6rem"
            margin="0 0 1.2rem 0"
          />
          <Placeholder
            display="flex"
            ldrWidth="320px"
            ldrHeight="1.6rem"
            margin="0 0 1.2rem 0"
          />
          <Placeholder display="flex" ldrWidth="320px" ldrHeight="1.6rem" />
        </div>
        <div className="contentRight">
          <Placeholder
            display="flex"
            ldrWidth="10rem"
            ldrHeight="2rem"
            margin="0 0 1rem 0"
          />
          <Placeholder
            display="flex"
            ldrWidth="13.5rem"
            ldrHeight="1.3rem"
            margin="0 0 1rem 0"
          />
          <Placeholder
            display="flex"
            ldrWidth="13.5rem"
            ldrHeight="3rem"
            margin="0 0 1rem 0"
          />
          <Placeholder display="flex" ldrWidth="13.5rem" ldrHeight="1.3rem" />
        </div>
      </ListingLoaderContent>
    </ListingLoader>
  );
};

const ListingLoader = styled.div`
  border-radius: 1.2rem;
  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.5);
  border: solid 0.1rem #fff;
  background-color: #ffffff;
  margin-bottom: 1.2rem;
`;
const ListingLoaderHdr = styled.div`
  padding: 1.6rem 3.6rem;
  display: flex;
  align-items: center;
  border-radius: 1.2rem;
  box-shadow: 0 0.2rem 0.5rem 0 rgba(0, 0, 0, 0.23);
  background-color: #ffffff;
`;
const ListingLoaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  .contentLeft {
    flex: 1;
    padding: 2rem 1.6rem;
  }
  .contentLeft__top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2.5rem;
  }
  .contentRight {
    width: 226px;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    padding: 2rem 1.6rem;
    border-left: 0.1rem #e5edf6 solid;
    align-items: flex-end;
  }
`;

export default ListingCardLoaderUI;
